import { ReactSVG } from "react-svg";
import { Button, Dropdown, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import filtericon from "../../../../assets/images/filter-icon.svg";
import editicon from "../../../../assets/images/edit-icon.svg";
import printicon from "../../../../assets/images/print-icon.svg";
import defaulticon from "../../../../assets/images/default-icon.svg";
import threedotvertical from "../../../../assets/images/three-dots-vertical.svg";
import deactivateicon from "../../../../assets/images/deactivate-icon.svg";
import deleteicon from "../../../../assets/images/delete-icon.svg";
import duplicateicon from "../../../../assets/images/duplicate-icon.svg";
import useInventory from "../../../../Hooks/useInventory";
import { useEffect, useState } from "react";
import { CreateBarcodeModel } from "./popUpModels/createBarcodeModel";
import { selectCurrentUserId } from "../../../../redux/auth/authSlice";
import { useAppSelector } from "../../../../redux/hooks";
import { toggleClass } from "../../../../utils/commonUtils";
import Loading from "../../../../components/LoadingPage/Loading";
import { EditBarcodeModel } from "./popUpModels/EditBarcodeModel";
import { DeleteConfModel } from "../../../../components/DeleteConfModel/deleteConfModel";
import { Barcode } from "../../../../redux/inventory/inventorySlice";
import { PrintBarcodePopUp } from "../printBarcodePopUp/printBarcodePopUp";
import { toast } from "react-toastify";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../../../utils/permissionUtils";

export const BarcodeManagementTab = ({ selectedItem, printBarcode, selectedLabel }: any) => {
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [defaultBarcodes, setDefaultBarcodes] = useState<Barcode>();
  const [getBarcodesList, setGetBarcodesList] = useState<any[]>([]);
  const { getBarcodesAPI, getBarcodesLoading } = useInventory();
  const [showCreateBarcodeModal, setshowCreateBarcodeModal] = useState(false);
  const [showEditBarcodeModal, setShowEditBarcodeModal] = useState(false);
  const [showDeleteBarcodeModal, setShowDeleteBarcodeModal] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy to clipboard");
  const [newBarcode, setNewBarcode] = useState("");
  const {
    getNewBarcodeAPI,
    getNewBarcodeLoading,
    barcodeCreateAPI,
    barcodeCreateLoading,
    barcodeEditAPI,
    barcodeEditLoading,
    barcodeDefaultAPI,
    barcodeDefaultLoading,
    barcodeDeactiveAPI,
    barcodeDeactiveLoading,
    barcodeActiveAPI,
    barcodeActiveLoading,
    barcodeDeleteAPI,
    barcodeDeleteLoading,
  } = useInventory();
  const [currentRecord, setCurrentRecord] = useState<any>();
  const currentUserId = useAppSelector(selectCurrentUserId);

  const isPermitted = useModulePermissions(PermissionModule.INVENTORY);
  const isPrintBarcodePermitted = isPermitted(PermissionIdentifier.PRINT_BARCODE);

  const toggleBarcodeModal = () => {
    toggleClass();
    setShowBarcodeModal(!showBarcodeModal);
  };

  const toggleCreateBarcodeModal = () => {
    toggleClass();
    if (!showCreateBarcodeModal) {
      getNewBarcodeAPI().then((res: any) => setNewBarcode(res));
    } else {
      setNewBarcode("");
    }
    setshowCreateBarcodeModal(!showCreateBarcodeModal);
  };
  const toggleEditBarcodeModal = () => {
    toggleClass();
    setShowEditBarcodeModal(!showEditBarcodeModal);
  };
  const toggleDeleteBarcodeModal = () => {
    toggleClass();
    setShowDeleteBarcodeModal(!showDeleteBarcodeModal);
  };

  const getBarcodeList = () => {
    getBarcodesAPI(selectedItem.id).then((res: any) => {
      if (!res) return;
      const sorted = [...res].sort((a: any, b: any) => {
        if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1; // Default always first
        if (a.isActive !== b.isActive) return a.isActive ? -1 : 1; // Active before Inactive
        return a.rxSRXId.localeCompare(b.rxSRXId); // Same group → sort by rxSRXId ascending
      }) || [];
      setGetBarcodesList(sorted);
    });
  };

  useEffect(() => {
    getBarcodeList();
  }, []);

  const createBarcode = (data: any) => {
    if (getBarcodesList.length > 0) {
      barcodeCreateAPI(data).then(getBarcodeList);
    } else {
      barcodeCreateAPI({ ...data, isDefault: true }).then(getBarcodeList);
    }
    toggleCreateBarcodeModal();
  };
  const editBarcode = (data: Barcode) => {
    if (data.isDefault) {
      getDefaultBarcodes();
    }
    barcodeEditAPI(data).then(getBarcodeList);
    toggleEditBarcodeModal();
  };
  const getDefaultBarcodes = () => {
    const defaultBarcodes = getBarcodesList.filter(
      (item: Barcode) => item.isDefault,
    );
    defaultBarcodes.forEach(async (item: Barcode) => {
      await barcodeEditAPI({ ...item, isDefault: false });
    });
    if (defaultBarcodes.length > 0) {
      getBarcodeList();
    }
  };
  const makeDefault = async (data: any) => {
    try {
      getDefaultBarcodes();
      barcodeDefaultAPI({
        id: data.id,
        updatedBy: currentUserId,
        isDefault: true,
      }).then(getBarcodeList);
    } catch { }
  };
  const deleteBarcode = async () => {
    try {
      const res = await barcodeDeleteAPI({ id: currentRecord?.id });
      if (res) {
        toggleDeleteBarcodeModal();
        getBarcodeList();
      }
    } catch (error) {
      console.error("Error deleting barcode:", error);
    }
  };
  const updateStatus = async (data: any) => {
    try {
      const api = data.isActive ? barcodeDeactiveAPI : barcodeActiveAPI;
      const res = await api({ id: data.id, updatedBy: currentUserId });
      if (res) getBarcodeList();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const renderTooltip = (props: any) => (
    <Tooltip id="copy-tooltip" {...props} className="copy-tooltip">
      {tooltipText}
    </Tooltip>
  );
  const handleCopy = async (rxSRXId: string) => {
    navigator.clipboard
      .writeText(rxSRXId)
      .then(() => {
        setTooltipText("Copied!");
        setTimeout(() => setTooltipText("Copy to clipboard"), 1500);
      })
      .catch(() => {
        setTooltipText("Failed to copy");
      });
  };
  return (
    <>
      <div className="inventory-tab-head">
        {getNewBarcodeLoading ||
          getBarcodesLoading ||
          barcodeCreateLoading ||
          barcodeEditLoading ||
          barcodeActiveLoading ||
          barcodeDeactiveLoading ||
          barcodeDeleteLoading ||
          barcodeDefaultLoading ? (
          <Loading />
        ) : null}
        <h4>
          Displaying {getBarcodesList.length} of {getBarcodesList.length}{" "}
          Results
        </h4>
        <div className="inventory-tab-action-wrapper">
          <div
            className="inventory-tab-action-box inventory-tab-action-add-barcode"
            onClick={toggleCreateBarcodeModal}
          >
            <i className="bi bi-plus"></i> Add Barcode
          </div>
          {/* <div className="inventory-tab-action-box inventory-tab-action-filter">
            <ReactSVG className="svg-box" wrapper="span" src={filtericon} />
          </div> */}
        </div>
      </div>
      <div className="inventory-profile-table-wrapper" style={{ overflow: "unset" }}>
        <Table bordered={false} hover={true}>
          <thead>
            <tr>
              <th>Barcode</th>
              <th>Serial No</th>
              <th>Status</th>
              <th>Default</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {getBarcodesList?.map((x: any) => (
              <tr key={x.id}>
                <td>
                  <span style={{ display: "flex", alignItems: "center", gap: '8px' }}>
                    {x.rxSRXId ?? ""}
                    {x.isDefault && (
                      <span className="status-box active">Default</span>
                    )}
                    <OverlayTrigger
                      placement="top"
                      overlay={renderTooltip}
                      delay={{ show: 250, hide: 400 }}
                    >
                      <span onClick={() => handleCopy(x.rxSRXId)} className="copy-icon k-cursor-pointer">
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={duplicateicon}
                          style={{ width: "auto" }}
                        />
                      </span>
                    </OverlayTrigger>
                  </span>
                </td>
                <td>{x.serialNo ?? ""}</td>
                <td>
                  <span
                    className={`status-circle  ${x.isActive ? "active" : "inactive"}`}
                  >{x.isActive ? "Active" : "Inactive"}</span>
                </td>
                <td>{x.isDefault ? "Yes" : "No"}</td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                      <ReactSVG
                        className="svg-box"
                        wrapper="span"
                        src={threedotvertical}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          updateStatus(x);
                        }}
                        disabled={x.isDefault && x.isActive}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={deactivateicon}
                        />
                        {x.isActive ? "Deactivate" : "Activate"}
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setCurrentRecord(x);
                          toggleEditBarcodeModal();
                        }}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={editicon}
                        />
                        Edit
                      </Dropdown.Item>
                      {isPrintBarcodePermitted && (
                        <Dropdown.Item
                          onClick={() => {
                            // setDefaultBarcodes(x);
                            // toggleBarcodeModal();
                            printBarcode(selectedLabel?.value, selectedItem, x.rxSRXId);
                          }}
                        >
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={printicon}
                          />
                          Print Barcode
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        onClick={() => {
                          setCurrentRecord(x);
                          toggleDeleteBarcodeModal();
                        }}
                        disabled={x.isDefault}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={deleteicon}
                        />
                        Delete
                      </Dropdown.Item>
                      {/* <Dropdown.Item onClick={() => makeDefault(x)}>
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={defaulticon}
                        />
                        Make Default
                      </Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <PrintBarcodePopUp
        showBarcodeModal={showBarcodeModal}
        toggleBarcodeModal={toggleBarcodeModal}
        printBarcode={printBarcode}
        defaultBarcodes={defaultBarcodes}
      />
      {showCreateBarcodeModal && (
        <CreateBarcodeModel
          selectedItem={selectedItem}
          selectCurrentUserId={currentUserId}
          toggleCreateBarcodeModal={toggleCreateBarcodeModal}
          createBarcode={createBarcode}
          newBarcode={newBarcode}
        />
      )}
      {showEditBarcodeModal && (
        <EditBarcodeModel
          currentRecord={currentRecord}
          currentUserId={currentUserId}
          toggleEditBarcodeModal={toggleEditBarcodeModal}
          editBarcode={editBarcode}
        />
      )}
      <DeleteConfModel
        showModal={showDeleteBarcodeModal}
        toggleModal={toggleDeleteBarcodeModal}
        deleteAction={deleteBarcode}
        modelName="barcode"
        recordName={currentRecord?.rxSRXId || ""}
      />
    </>
  );
};
